import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgxEchartsDirective } from 'ngx-echarts';
import type { EChartsOption } from 'echarts';
import { SkillsRadar } from '../../models';
import { CHART_AXIS_LINE, CHART_LABEL_MEDIUM, CHART_LINE_COLOR } from '../../../../shared/ui/charts/chart-theme';

@Component({
  selector: 'app-skills-chart',
  imports: [NgxEchartsDirective, MatIconModule],
  template: `
    <div class="bg-pmdf-surface rounded-pmdf-card shadow-pmdf-card p-4">
      <div class="flex items-center gap-2 mb-3">
        <mat-icon class="icon-base text-pmdf-primary">military_tech</mat-icon>
        <h3 class="text-sm font-semibold text-pmdf-text-primary">Suas Habilidades</h3>
      </div>
      <div echarts [options]="chartOptions()" class="h-64 w-full"></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillsChart {
  data = input.required<SkillsRadar>();

  chartOptions = computed<EChartsOption>(() => {
    const d = this.data();
    return {
      radar: {
        indicator: d.dimensions.map(name => ({ name, max: 100 })),
        shape: 'polygon',
        splitNumber: 5,
        axisName: {
          color: CHART_AXIS_LINE,
          fontSize: 11,
        },
        splitLine: {
          lineStyle: { color: CHART_LABEL_MEDIUM },
        },
        splitArea: {
          show: true,
          areaStyle: { color: ['transparent', 'rgb(17 24 39 / 0.05)'] },
        },
        axisLine: {
          lineStyle: { color: CHART_AXIS_LINE },
        },
      },
      series: [
        {
          type: 'radar',
          data: [
            {
              value: d.values,
              areaStyle: {
                color: 'rgb(15 59 111 / 0.25)',
              },
              lineStyle: {
                color: CHART_LINE_COLOR,
                width: 2,
              },
              itemStyle: {
                color: CHART_LINE_COLOR,
              },
              symbol: 'circle',
              symbolSize: 6,
            },
          ],
        },
      ],
    };
  });
}
